import React from "react";

const TONE = {
  ok: "text-emerald-800", partial: "text-amber-800", capped: "text-red-700", none: "text-red-700", test: "text-zinc-500",
};
const names = (cov) => cov.buyers.map((b) => `${b.name}${b.capped ? " (capped)" : ""}`).join(", ");

export const reachesNoBuyer = (cov) => cov && (cov.status === "none" || cov.status === "capped");

// One line under each Traffic Access page: which buyers its leads reach.
export function CoverageLine({ cov, testId }) {
  if (!cov) return null;
  const text = {
    ok: `Leads go to: ${names(cov)}`,
    partial: `Leads go to: ${names(cov)} · ${cov.states}/51 states`,
    capped: `All buyers capped today: ${names(cov)}`,
    none: "No buyer connected",
    test: "Test page",
  }[cov.status];
  return (
    <div className={`mt-1 text-[10px] font-bold leading-snug ${TONE[cov.status]}`} title={cov.note}
         data-testid={testId} data-status={cov.status}>
      {text}
      {cov.status !== "ok" && cov.status !== "test" && <div className="font-normal">{cov.note}</div>}
    </div>
  );
}
